// extracted by css-extract-rspack-plugin
export default {"Explanation":"QFoNI"};